import React, { FC, useEffect } from "react";
import { Switch } from "@evergis/ui";
import { useTranslation } from "react-i18next";

import { CopySwitchContainer, CopySwitchLabel, CopySwitchWrapper } from "./styled";

import { useToggle } from "../../../../../hooks/useToggle";

import { CopySwitchProps } from "./types";

export const CopySwitch: FC<CopySwitchProps> = ({ onToggle, hidden }) => {
  const { t } = useTranslation("dialogs");
  const [checked, toggleChecked] = useToggle(false);

  useEffect(() => {
    onToggle && onToggle(checked);
  }, [checked, onToggle]);

  return (
    <CopySwitchContainer hidden={hidden}>
      <CopySwitchLabel active={!checked} onClick={() => checked && toggleChecked()}>
        {t("copyResource.toExistingLayer")}
      </CopySwitchLabel>
      <CopySwitchWrapper>
        <Switch isOn onChange={toggleChecked} checked={checked} />
      </CopySwitchWrapper>
      <CopySwitchLabel active={checked} onClick={() => !checked && toggleChecked()}>
        {t("copyResource.toNewLayer")}
      </CopySwitchLabel>
    </CopySwitchContainer>
  );
};
